import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { Typography, Row, Col, Skeleton } from 'antd';
import './DonutChart';
import { useSelector } from 'react-redux';
import { formatCurrency } from '../../assets/helpers';

const { Text } = Typography;

const AUMDonutChart = ({ data, loading = false }) => {
    const { format } = useSelector((state) => state.priceFormat);

  const chartdata = [
    { name: 'Pending', value: data?.pending, color: '#ff6b47' },
    { name: 'Redeemed', value: data?.redeemed, color: '#4c7eff' }
  ];


  return (
    <div className="aum-donut-container">
      {
        loading ? (
          <Skeleton.Input size='large' style={{ height: '200px', borderRadius: "50%", marginLeft: '20px' }} />
        ) : (
          <>
            <ResponsiveContainer width={140} height={140}>
              <PieChart>
                <Pie
                  data={chartdata}
                  dataKey="value"
                  innerRadius={30}
                  outerRadius={70}
                  startAngle={90}
                  endAngle={-270}
                  paddingAngle={1}
                >
                  {chartdata?.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>

            <div className="aum-legend">
              {chartdata?.map((item, idx) => (
                <Row key={idx} align="middle" className="legend-item">
                  <div className="dot" style={{ backgroundColor: item.color }} />
                  <Col style={{ textAlign: 'left' }}>
                    <Text type="secondary" className="label">{item.name}</Text>
                    <br />
                    <Text strong className="value">{formatCurrency(item?.value,format)}</Text>
                  </Col>
                </Row>
              ))}
            </div>
          </>
        )
      }
    </div>
  );
};

export default AUMDonutChart;
